__webpack_require__.p = "/suyash-portfolio/";